<template>
  <div>
    <common-filter-form :filter="filterForm" :fields="allFields" :default-common-fields="defaultCommonFields" :default-more-fields="defaultMoreFields" config-key="serviceFilterConfig" @change="handleFieldChange" @search="handleSearch" @reset="handleReset">
      <template slot="field" slot-scope="{ field, form, reset, labelCol, wrapperCol }">
        <service-filter-form-item
          :form="form"
          :field="field"
          :options="{
            serviceSpecialTests: serviceSpecialTests,
            serviceStrategys: serviceStrategys,
            projectOptions: projectOptions
          }"
          :reset="reset"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          @change="handleFieldChange"
        />
      </template>
    </common-filter-form>
  </div>
</template>

<script>
import { projectList } from '@/api/project/project';
import { serviceSpecialTests } from '@/utils/dictionary';

import CommonFilterForm from '@/components/CommonFilterForm';
import ServiceFilterFormItem from '@/pages/system/components/ServiceFilterFormItem';

export default {
  name: 'ServiceFilterForm',
  components: {
    CommonFilterForm,
    ServiceFilterFormItem
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {};
      }
    },
    serviceStrategys: {
      type: Object,
      default: () => {
        return {};
      }
    },
    type: {
      type: String,
      default: 'system'
    }
  },
  data() {
    return {
      serviceSpecialTests,
      filterForm: { ...this.value },
      projectOptions: [],
      // 所有可用的筛选项配置
      allFields: [
        { key: 'name', label: '服务名称', span: 6 },
        { key: 'service_type', label: '服务类型', span: 6 },
        { key: 'owner', label: '负责人', span: 6 },
        { key: 'project_id', label: '所属项目', span: 6, show: ['system'].includes(this.type) },
        { key: 'auto_deploy', label: '自动发布', span: 6 },
        { key: 'self_deploy', label: '自助发布', span: 6 },
        { key: 'special_test', label: '专项测试', span: 6 },
        { key: 'language', label: '语言', span: 6 },
        { key: 'strategy', label: '发布策略', span: 6 }
      ],
      // 默认常用筛选字段
      defaultCommonFields: ['name', 'service_type', 'owner'],
      // 默认更多筛选字段
      defaultMoreFields: ['project_id', 'auto_deploy', 'self_deploy', 'special_test', 'language', 'strategy']
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          this.filterForm = { ...newVal };
        }
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.getProjectList();
  },
  methods: {
    handleFieldChange({ key, value }) {
      this.$set(this.filterForm, key, value);
      this.handleSearch();
    },

    handleSearch() {
      this.$emit('input', this.filterForm);
      this.$emit('change', this.filterForm);
    },

    handleReset() {
      const defaultForm = {
        name: null,
        service_type: null,
        owner: null,
        project_id: null,
        auto_deploy: null,
        self_deploy: null,
        special_test: null,
        language: null,
        strategy: null
      };
      this.filterForm = { ...defaultForm };
      this.$emit('reset', this.filterForm);
    },

    // 获取项目列表
    getProjectList() {
      projectList({ page_index: 1, page_size: 100 }).then(res => {
        this.projectOptions = res.data.projects;
      });
    }
  }
};
</script>

<style lang="less" scoped>
::v-deep .search-form {
  .ant-form-item {
    display: flex;
    margin-bottom: 0;
  }
  .ant-form-item-control-wrapper {
    flex: 1;
  }
}
</style>
